import getDateRange from './getDateRange'

const isUploadDateFunction = uploadDate =>
  typeof uploadDate?.rangeQuery === 'function'
    ? { gte: +getDateRange(uploadDate?.staticValue)?.gte, lte: +getDateRange(uploadDate?.staticValue)?.lte }
    : uploadDate?.rangeQuery

export default isUploadDateFunction
